import $api from 'http/index';
import { getOptions } from 'helpers/getOptions';
import { businessDirectoryActions } from './businessDirectorySlice';

const BASE = `${process.env.REACT_APP_BASE_URL}/business-directory`;

export const PAGE_SIZE = 25;

const errorMessage = (error) => error?.response?.data?.message || error?.message || 'Request failed';

export const fetchContacts =
  ({ append } = {}) =>
  async (dispatch, getState) => {
    const { filters, rows } = getState().businessDirectory;
    dispatch(businessDirectoryActions.fetchStarted());
    try {
      const { data } = await $api.get(BASE, {
        ...getOptions(),
        params: {
          ...(filters.searchValue && { searchValue: filters.searchValue }),
          ...(filters.locationId && { locationId: filters.locationId }),
          sortOrder: filters.sortOrder,
          skip: append ? rows.length : 0,
          limit: PAGE_SIZE,
        },
      });
      dispatch(
        businessDirectoryActions.fetchSucceeded({
          rows: data,
          hasMore: data.length === PAGE_SIZE,
          append,
        })
      );
    } catch (error) {
      dispatch(businessDirectoryActions.fetchFailed(errorMessage(error)));
    }
  };
